export enum AlertType {
  PLAIN,
  ERROR,
  WARNING,
  INFO
}
